// extracted by mini-css-extract-plugin
module.exports = {"prev":"SliderArrows_prev__2fxkI","next":"SliderArrows_next__1xn2z","leftArrow":"SliderArrows_leftArrow__33DVp","rightArrow":"SliderArrows_rightArrow__3KMLH"};